<template>
    <div class="monitoring-increase-limit">
        <VLinkUnderline to="#"
                        class="monitoring-increase-limit__link"
                        icon-position="right"
                        icon="arrow-half-right"
        >
            Увеличить лимиты
        </VLinkUnderline>
        <LineChart color="blue" :value="30" show-value />
    </div>
</template>

<script setuo lang="ts">
    </script>

<style lang="scss" scoped>
    .monitoring-increase-limit {
        width: 100%;
        min-width: 219px;
        padding: 12px 16px;
        border-radius: 10px;
        background-color: var(--indigo-50);

        &__link {
            margin-bottom: 24px;

            @include mulish14r;

            :deep(.icon) {
                width: 12px;
                height: 12px;
            }
        }
    }
</style>
